import React from "react";
import LeftNavbar from "./LeftNavbar";
import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import ServicesSection from "./ServicesSection";
import Footer from "./Footer";
export default function HomeIndex() {
  return (
    <div className="relative min-h-screen bg-gray-50 overflow-x-hidden">
      
      {/* FLOATING NAVBAR (always on top) */}
      <LeftNavbar />

      {/* HERO – FULL WIDTH */}
      <section className="relative z-0">
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <Footer />
      </section>

     

    </div>
  );
}
